import { FC, useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import WithHeaderandFooter from "../hoc";
import HubSplashScreen from "../pages/splashscreen";

import { PublicRoutes, AuthenticatedRoutes, ManufacturerRoutes, ManufacturerRoutesWithoutEOB, AuthenticatedRoutesWithEoB } from "./AppRoutes";
import { FooterContext } from "src/context/footerContext";
import { AuthContext } from "src/context/authContext";
import StatsProvider from "src/context/statsContext";
import { getRemainingTime } from "src/helpers/session";
import IdleSession from "src/components/idleSession";

const HubRoutes: FC = (): JSX.Element => {
  const { isUserAuthorized, isManufacturer, userData } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);
  const location = useLocation();
  const { hcpIdleTime, manIdleTime } = getRemainingTime()

  useEffect(() => {
    if (isAccordianShown)
      changeAccordianVisibility();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const manufacturerRoutes = (
    <Route element={<StatsProvider />}>
      {ManufacturerRoutes.map((route) => (
        <Route
          key={route.route}
          path={route.route}
          index={route.isIndex}
          element= {
            route.removeHeaderandFooter === false ?
              <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
          }
        />
      ))}
    </Route>
  );

  const authentictedRoutesWithEoB = AuthenticatedRoutesWithEoB.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element={
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
      }
    />
  ));

  const authentictedRoutes = AuthenticatedRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element={
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
      }
    />
  ))

  const publicRoutes = PublicRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element= {
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component/>
      }
    />
  ));

  const manufacturerRoutesWithoutEOB = (
  <Route element={<StatsProvider />}>
    {ManufacturerRoutesWithoutEOB.map((route) => (
      <Route
        key={route.route}
        path={route.route}
        index={route.isIndex}
        element={
          route.removeHeaderandFooter === false
            ? <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
        }
      />
    ))}
  </Route>
);

  return (
    <>
      <Routes>
        <Route
          path="/patient" 
          element={
            <iframe
              src="/patient.html"
              width="100%"
              height="100%"
              title="EXPAREL | Non-opioid Analgesic Pain Management"
            />
          } 
        />
        {isUserAuthorized && userData ? (
          isManufacturer ? (
           (userData?.eob_button || userData?.ref_type === "fam_rm") ?
            manufacturerRoutes : manufacturerRoutesWithoutEOB
          ) : (
            userData && userData.eob_button ?
              authentictedRoutesWithEoB : authentictedRoutes
          )
        ) : (
          publicRoutes
        )}

        <Route path="/" element={<HubSplashScreen />} />
        <Route path="*" element={<HubSplashScreen />} />
      </Routes>

      {isUserAuthorized && <IdleSession idleTime={isManufacturer ? manIdleTime : hcpIdleTime} />}
    </>
  );
};

export default HubRoutes;
